import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        msg_subject: "",
        message: "",
        gridCheck: false,
    });

    const [responseMessage, setResponseMessage] = useState("");

    // Handle input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.gridCheck) {
            setResponseMessage("Please agree to the Terms & Conditions.");
            return;
        }

        try {
            const response = await axios.post("/api/contact", formData);
            setResponseMessage(response.data.message);
            setFormData({ name: "", email: "", phone: "", msg_subject: "", message: "", gridCheck: false });
        } catch (error) {
            setResponseMessage("Error sending message. Please try again.");
        }
    };
    const handleKeyDown = (e) => {
        // Allow only numbers, backspace, and arrow keys
        if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
          e.preventDefault();
        }
      };
      const contacten ={
        "1": "Contact Us",
        "2": "Home",
        "3": "Send Us A Message",
        "4": "Visit us anytime",
        "5": "230, 2B Cross, Kasturi Nagar, Bengaluru -560043",
        "6": "Send an Email",
        "7": "Call Centre",
        "8": "Send Message",
        "9": "I agree to the Terms & Conditions and Privacy Policy",
        "10": "Name",
        "11": "Email",
        "12": "Phone Number",
        "13": "Subject",
        "14": "Your Messages.."
    }
    
    const contactka ={
        "1": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
        "2": "ಮರಳಿ ಪ್ರಥಮ ಪುಟಕ್ಕೆ",
        "3": "ನಮಗೆ ಒಂದು ಸಂದೇಶ ಕಳುಹಿಸಿ",
        "4": "ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ನಮ್ಮನ್ನು ಭೇಟಿ ಮಾಡಿ",
        "5": "230, 2ಬಿ ಕ್ರಾಸ್, ಕಸ್ತೂರಿ ನಗರ, ಬೆಂಗಳೂರು -560043",
        "6": "ಇಮೇಲ್ ಕಳುಹಿಸಿ",
        "7": "ಕಾಲ್ ಸೆಂಟರ್",
        "8": "ಸಂದೇಶ ಕಳುಹಿಸಿ",
        "9": "ನಾನು ಷರತ್ತುಗಳು ಮತ್ತು ಗೌಪ್ಯತೆ ಕ್ಕೆ ಒಪ್ಪುತ್ತೇನೆ",
        "10": "ಹೆಸರು",
        "11": "ಇಮೇಲ್",
        "12": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
        "13": "ವಿಷಯ",
        "14": "ನಿಮ್ಮ ಸಂದೇಶಗಳು.."
    }
    

    const contactte ={
        "1": "మమ్మల్ని సంప్రదించండి",
        "2": "హోం",
        "3": "మాకు సందేశం పంపండి",
        "4": "ఎప్పుడు అయినా మమ్మల్ని సందర్శించండి",
        "5": "230, 2బీ క్రాస్, కస్తూరి నగర్, బెంగళూరు -560043",
        "6": "ఇమెయిల్ పంపండి",
        "7": "కాల్ సెంటర్",
        "8": "సందేశం పంపండి",
        "9": "నేను నిబంధనలు & షరతులు మరియు గోప్యతా విధానాన్ని అంగీకరిస్తున్నాను",
        "10": "పేరు",
        "11": "ఇమెయిల్",
        "12": "ఫోన్ నంబర్",
        "13": "విషయం",
        "14": "మీ సందేశాలు.."
    }
    
   const contacthi ={
    "1": "संपर्क करें",
    "2": "होम",
    "3": "हमें संदेश भेजें",
    "4": "कभी भी हमसे मिलें",
    "5": "230, 2B क्रॉस, कस्तूरी नगर, बेंगलुरु -560043",
    "6": "ईमेल भेजें",
    "7": "कॉल सेंटर",
    "8": "संदेश भेजें",
    "9": "मैं नियम और शर्तों एवं गोपनीयता नीति से सहमत हूं",
    "10": "नाम",
    "11": "ईमेल",
    "12": "फ़ोन नंबर",
    "13": "विषय",
    "14": "आपका संदेश.."
};

    const [contact, setHomeen] = useState(contacten)

    useEffect(() => {
        const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
    switch (storedLanguage) {
        case "kn":
            setHomeen(contactka);
            break;
        case "te":
            setHomeen(contactte);
            break;
        case "ta":
            setHomeen(contacten);
            break;
            case "hi":
                setHomeen(contacthi);
                break;
        default:
                setHomeen(contacten);
    }

}, []);
    return (
        <>

            <div class="content-wrapper">

                {/* <!-- Breadcrumb Start --> */}
                <div class="breadcrumb-wrap bg-f br-1">
                    <div class="container">
                        <div class="breadcrumb-title">
                            <h2>{contact["1"]}</h2>
                            <ul class="breadcrumb-menu list-style">
                                <li><a href="index.html">{contact["2"]}</a></li>
                                <li>{contact["1"]}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                {/* <!-- Breadcrumb End --> */}

                {/* <!-- Contact Us section Start --> */}
                <section class="contact-us-wrap ">
                    <div class="container">

                        <div class="row gx-5">
                            <div class="col-xl-7 col-lg-7 col-12">
                                <div class="contact-form">
                                    <h3>{contact["3"]}</h3>
                                    <form class="form-wrap" onSubmit={handleSubmit} id="contactForm">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="text" name="name" placeholder={contact["10"]} id="name"
                                                        required data-error="Please enter your name" value={formData.name} onChange={handleChange} />
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="email" name="email" id="email" required
                                                        placeholder={contact["11"]} data-error="Please enter your email" value={formData.email} onChange={handleChange} />
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input
                                                        type="tel"
                                                        name="phone"
                                                        id="phone"
                                                        required
                                                        placeholder={contact["12"]}
                                                        data-error="Please enter a valid phone number"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                        maxLength={10}
                                                        onKeyDown={handleKeyDown}
                                                        pattern="\d{10}"
                                                        inputMode="numeric"
                                                    />
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="text" name="msg_subject" placeholder={contact["13"]} id="msg_subject" required data-error="Please enter your subject" value={formData.msg_subject} onChange={handleChange} />
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group v1">
                                                    <textarea name="message" id="message" placeholder={contact["14"]} cols="30" rows="10" required data-error="Please enter your message" value={formData.message} onChange={handleChange}></textarea>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="form-check checkbox">
                                                    <input
                                                        name="gridCheck"
                                                        value="I agree to the terms and privacy policy."
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="gridCheck"
                                                        required
                                                        checked={formData.gridCheck} onChange={handleChange}
                                                    />
                                                    <label class="form-check-label" for="gridCheck">
                                                    {contact["9"]}</label>
                                                    <div class="help-block with-errors gridCheck-error"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <button type="submit" class="btn style1">{contact["8"]}</button>
                                                <div id="msgSubmit" class="h3 text-center hidden"></div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-xl-5 col-lg-5 col-md-12">
                                <div class="comp-map">
                                    <div class=" justify-content-center pb-75">
                                        <div class="">
                                            <div class="contact-item">
                                                <span class="contact-icon">
                                                    <i class="flaticon-map"></i>
                                                </span>
                                                <div class="contact-info">
                                                    <h3>{contact["4"]}</h3>
                                                    <p>{contact["5"]}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="">
                                            <div class="contact-item">
                                                <span class="contact-icon">
                                                    <i class="flaticon-email-2"></i>
                                                </span>
                                                <div class="contact-info">
                                                    <h3>{contact["6"]}</h3>
                                                    <a href="mailto:business@terrainternational.in?subject=Inquiry&body=Hello,%20I%20would%20like%20to%20know%20more."><span>business@terrainternational.in</span></a>
                                                    {/* <a href="/cdn-cgi/l/email-protection#2d5e585d5d425f596d59484144034e4240"><span class="__cf_email__" data-cfemail="fd8e888d8d928f89bd89989194d39e9290">[email&#160;protected]</span></a> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div >
                                            <div class="contact-item">
                                                <span class="contact-icon">
                                                    <i class="flaticon-call"></i>
                                                </span>
                                                <div class="contact-info">
                                                    <h3>{contact["7"]}</h3>
                                                    <a style={{color:"#000"}} href="tel:+917022519222">+91  7022519222</a><a style={{color:"#000"}} href="tel:+917022520222">+91 7022520222</a>
                                                    {/* <a href="tel:88098787869">+55 576 234532</a> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- Contact Us section End --> */}

            </div>
        </>
    );
};
export default Contact;